'use client';

import { Fragment } from 'react';

import { Highlight } from '@/components/squeeze';
import { DATA_KEYS } from '@/consts/dataKeys';
import {
  ITEM_IDS,
  PRODUCT_ITEM_TYPE_NAMES,
  type ProductItemTypeType,
} from '@/consts/items';

import { useDataProvider } from '../../components/DataProvider/useDataProvider';
import { useFlowContext } from '../../hooks/useFlowContext';

export const ProductHighlights = () => {
  const { treatmentCategory, brand } = useFlowContext();
  const subscriptions = useDataProvider(DATA_KEYS.subscriptions);

  const products = subscriptions
    .filter((subscription) => {
      return subscription.treatmentCategory === treatmentCategory;
    })
    .flatMap((subscription) => {
      return subscription.items;
    });

  if (!products) {
    return null;
  }

  return (
    <Highlight
      state="success"
      size="sm"
      className={`cur-font-body ${brand === 'curology' ? 'cur-rounded-b-md' : ''}`}
    >
      <p>
        <strong>Here&apos;s what&apos;s in your trial box:</strong>
      </p>
      {products.map((item, index) => {
        return (
          <Fragment key={item.name}>
            {item.trialVersionId === ITEM_IDS.smallDeepCleanse
              ? 'Deep Cleanse'
              : PRODUCT_ITEM_TYPE_NAMES[item.type as ProductItemTypeType]}
            {item.isPrescription && <sup>Rx</sup>}
            {index + 1 !== products.length && ', '}
          </Fragment>
        );
      })}
    </Highlight>
  );
};
